import { Network } from "lucide-react";

const t = {
  fr: {
    title: "Organigramme",
    subtitle: "Structure Organisationnelle EcoLunch",
  },
  en: {
    title: "Org Chart",
    subtitle: "EcoLunch Organizational Structure",
  },
};

export default function OrgChartSection({ lang }) {
  const c = t[lang];
  return (
    <section id="orgchart" data-testid="orgchart-section" className="py-16 sm:py-24 bg-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary/20 mb-6 glow-primary">
            <Network className="h-8 w-8 sm:h-10 sm:w-10 text-primary" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">{c.title}</h2>
          <p className="text-lg sm:text-xl text-white/70">{c.subtitle}</p>
        </div>
        <div className="rounded-2xl border border-primary/20 overflow-hidden bg-white">
          <iframe
            src="https://orga.ecotechsystem.ca"
            title="EcoLunch Organigramme"
            className="w-full border-0"
            style={{ height: "80vh", minHeight: "600px" }}
            allow="fullscreen"
          />
        </div>
      </div>
    </section>
  );
}
